import { gameArea } from "../utils/gameArea";
import SoundManager from "../managers/SoundManager";

export default class HUDScene extends Phaser.Scene  {
    healthLabel: Phaser.GameObjects.Text;
    chargeLabel: Phaser.GameObjects.Text;
    health: number = 100;
    graphics: Phaser.GameObjects.Graphics;
    charge: any = 100;
    cornerRadius: number = 4;
    healthBarPosition: Phaser.Math.Vector2 = new Phaser.Math.Vector2(200,gameArea.screenHeight - 128 - 36)
    chargeBarPosition: Phaser.Math.Vector2 = new Phaser.Math.Vector2(200,gameArea.screenHeight - 64 - 36)
    barWidth:number = 200;
    barHeight: number = 32;
    redraw: boolean = true;
    countInText: Phaser.GameObjects.Text;

    constructor(){
        super({key: "HUDScene"});
    }

    create(){
        this.graphics = this.add.graphics();
        this.healthLabel = this.add.text(
            160,
            gameArea.screenHeight - 128,
            "HEALTH",
            { fontFamily: "Practice", fontSize: 32, stroke: '#000', strokeThickness: 3 }
        );
        this.healthLabel.setOrigin(1,1);
        this.chargeLabel = this.add.text(
            160,
            gameArea.screenHeight - 64,
            "CHARGES",
            { fontFamily: "Practice", fontSize: 32, stroke: '#000', strokeThickness: 3 }
        );
        this.chargeLabel.setOrigin(1,1);

        this.countInText = this.add.text(gameArea.screenWidth/2, gameArea.screenHeight/2, '3',
            { fontFamily: 'Practice', fontSize: 120, align: "center", stroke: '#000', strokeThickness: 3 }
        );
        this.countInText.setOrigin(0.5);
    }

    setHealth(health: number){
        if(this.health === health) return;
        this.health = health;
        this.redraw = true;
    }

    setCharge(charge: number){
        if(this.charge === charge) return;
        this.charge = charge;
        this.redraw = true;
    }

    doCountIn(cb: Function){
        let countDown = 3;
        this.countInText.setText(countDown.toString());
        this.countInText.setVisible(true);
        this.countInText.setAlpha(1);
        this.scene.bringToTop();
        SoundManager.playSfx('countInNormal');
        this.tweens.add({
          targets: this.countInText,
          alpha: { from: 1, to: 0 },
          delay: 500,
          duration: 500,
          yoyo: true,
          repeat: countDown - 1,
          onYoyo: () => {
            this.countInText.setVisible(true);
            countDown -= 1;
            if(countDown === 0){
              this.countInText.setText("fight!");
              //SoundManager.playSfx('countInFinal');
              SoundManager.playMusic("battleTheme");
            }else{
              this.countInText.setText(countDown.toString());
              SoundManager.playSfx('countInNormal');
            }
          },
          onComplete: () => {
            this.tweens.add({
              targets: this.countInText,
              alpha: { from: 1, to: 0 },
              duration: 500,
              onComplete: ()=> {
                this.countInText.setVisible(false);
                cb();
              }
            });
          }
        });
    }
    
    draw(){
        if(!this.redraw) return;
        this.graphics.clear();

        //draw health bar
        this.graphics.lineStyle(2,0X000000,0.80);
        this.graphics.fillStyle(0XFFFFFF,0.40);
        this.graphics.fillRoundedRect(
            this.healthBarPosition.x,this.healthBarPosition.y,
            this.barWidth,this.barHeight,this.cornerRadius);
        this.graphics.fillStyle(0X009900,0.80);
        if(this.health > this.cornerRadius){
            this.graphics.fillRoundedRect(
                this.healthBarPosition.x,this.healthBarPosition.y,
                this.barWidth * (this.health/100),this.barHeight,this.cornerRadius);
        }
        this.graphics.strokeRoundedRect(
            this.healthBarPosition.x,this.healthBarPosition.y,
            this.barWidth,this.barHeight,this.cornerRadius);
        
        //draw charge bar
        const segmentMargin = 10;
        const segmentCount = 4;
        const segmentWidgetWidth = (this.barWidth - ( segmentMargin * (segmentCount -1) )) / segmentCount;
        let chargeSegmentValues = [];
        let number = this.charge;
        while (number > 0) {
            chargeSegmentValues.push(Math.min(number, 25));
            number = number - 25;
        }
        chargeSegmentValues = chargeSegmentValues.concat([0,0,0,0]).slice(0,4);

        for (let idx = 0; idx < 4; idx++) {
            this.graphics.lineStyle(2,0X000000,0.80);
            this.graphics.fillStyle(0XFFFFFF,0.40);
            const segmentXOffset = this.chargeBarPosition.x + ( (segmentWidgetWidth + segmentMargin) * idx );
            this.graphics.fillRoundedRect(
                segmentXOffset,this.chargeBarPosition.y,
                segmentWidgetWidth,this.barHeight,this.cornerRadius);
            
            if(chargeSegmentValues[idx] > this.cornerRadius){
                this.graphics.fillStyle(0X0000FF,0.80);
                this.graphics.fillRoundedRect(
                    segmentXOffset,this.chargeBarPosition.y,
                    segmentWidgetWidth * ( chargeSegmentValues[idx]/25 ),this.barHeight,this.cornerRadius);
            }
            this.graphics.strokeRoundedRect(
                segmentXOffset,this.chargeBarPosition.y,
                segmentWidgetWidth,this.barHeight,this.cornerRadius);

        }

        this.redraw = false;

    }
}